import { useCallback, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { i18n } from '../../language';
import { TabBar } from '../../components';
import { authNameE } from '../../utils/userFuncs';
import { LoginPop } from '../../components/Login';
import useBarcodeListener from '../../utils/useBarcodeListener';
import { VIEW_REQUEST_LEND_NEW_LOAN_REQUEST, VIEW_REQUEST_BORROW_NEW_LOAN_REQUEST } from '../../comm/commandQRcode';
import { equipmentAPI } from '../../apis';
import { EQUIPMENT_INTERVAL } from '../../comm/constant';
import { isSessionValid } from '../../utils/check';
import ViewRequestTab from './ViewRequestTab';
import ManageEquipmentTab from './ManageEquipmentTab';
import UpdateEquipmentStatus from './UpdateEquipmentStatus';
import RemarkTab from './RemarkTab';

const useStyle = makeStyles(() => ({
  root: {
    position: 'fixed',
    top: '4.375rem',
    left: '6.25rem',
    right: '0',
    bottom: '0',
    margin: '1.813rem 3.438rem 1.25rem 3.438rem',
    display: 'flex',
    flexDirection: 'column',
  },
}));
const initTabData = () => [
  {
    id: 'ViewRequest',
    testID: 'dwp-weq-tab-ViewRequest',
    flag: true,
    component: <ViewRequestTab />,
    title: i18n.t('EQUIPMENT_VIEWREQUEST'),
    width: '14.875rem',
  },
  {
    id: 'ManageEquipment',
    testID: 'dwp-weq-tab-ManageEquipment',
    flag: false,
    component: <ManageEquipmentTab />,
    title: i18n.t('EQUIPMENT_MANAGE_EQUIPMENT'),
    width: '14.875rem',
  },
  // {
  //   id: 'Remark',
  //   testID: 'dwp-weq-tab-Remark',
  //   flag: false,
  //   component: <RemarkTab />,
  //   title: 'Remark' || i18n.t('EQUIPMENT_REMARK'),
  //   width: '14.875rem',
  // },
];

const handleBarcodeListenerToNewLendRequest = ({ setTabData, setTabFlagVal, setNewLendRequestOpen }) => {
  setTabData((val) => {
    if (Array.isArray(val)) {
      if (val.length === 1) {
        val[0].flag = true;
      }
      if (val.length === 2) {
        val[1].flag = false;
        setTabFlagVal({ barcode: true, tab: 1 });
        setNewLendRequestOpen(true);
      }
    }
    return [...val];
  });
};

const handleBarcodeListenerToNewBorrowRequest = ({ setTabData, setTabFlagVal, setNewLendRequestOpen }) => {
  setTabData((val) => {
    if (Array.isArray(val)) {
      if (val.length === 1) {
        val[0].flag = true;
      }
      if (val.length === 2) {
        val[1].flag = false;
      }
    }
    return [...val];
  });
  setTabFlagVal({ barcode: true, tab: 2 });
  setNewLendRequestOpen(true);
};

const WardEquipment = () => {
  const classes = useStyle();
  const [tabData, setTabData] = useState(initTabData());
  const loginInfo = useSelector((state) => state.loginInfo);
  const [refresh, setRefresh] = useState(false);
  const [stopRefresh, setStopRefresh] = useState(false);
  const [barcodeListenerCtrl, setBarcodeListenerCtrl] = useState(true);
  const roleMap = useSelector((state) => state.roleMap);
  const [tabFlagVal, setTabFlagVal] = useState({ barcode: false, tab: 1 });
  const [newLendRequestOpen, setNewLendRequestOpen] = useState(false);
  const [displayTvDashboard, setDisplayTvDashboard] = useState(false);

  // barcode枪
  useBarcodeListener((e) => {
    if (roleMap[authNameE.equipment_create_Loan_Request_Requestor_Provider_ward]) {
      if (e === VIEW_REQUEST_LEND_NEW_LOAN_REQUEST) {
        handleBarcodeListenerToNewLendRequest({ setTabData, setTabFlagVal, setNewLendRequestOpen });
      } else if (e === VIEW_REQUEST_BORROW_NEW_LOAN_REQUEST) {
        handleBarcodeListenerToNewBorrowRequest({ setTabData, setTabFlagVal, setNewLendRequestOpen });
      } else {
        setNewLendRequestOpen(false);
      }
    }
  }, barcodeListenerCtrl);

  // 獲取 provider list
  const getProvider = useCallback(async () => {
    try {
      const { result } = await equipmentAPI.getProvider({ hospitalId: loginInfo.hospitalId, wardId: loginInfo.wardId });

      if (_.some(result.provides, (item) => item.wardId === loginInfo.wardId)) {
        setTabData(initTabData());
        setDisplayTvDashboard(true);
      } else {
        setTabData((preTab) => [{ ...preTab[0], flag: true }]);
        setDisplayTvDashboard(false);
      }
    } catch (error) {
      console.log(error);
    }
  }, [loginInfo]);

  useEffect(() => {
    (async () => {
      await getProvider();
    })();
  }, [getProvider]);

  if (tabData.some((item) => item.id === 'ViewRequest')) {
    tabData.find((item) => item.id === 'ViewRequest').component = (
      <ViewRequestTab
        refresh={refresh}
        setStopRefresh={setStopRefresh}
        tabFlagVal={tabFlagVal}
        newLendRequestOpen={newLendRequestOpen}
        setBarcodeListener={setBarcodeListenerCtrl}
        setTabFlagVal={setTabFlagVal}
        setNewLendRequestOpen={setNewLendRequestOpen}
      />
    );
    tabData.find((item) => item.id === 'ViewRequest').title = i18n.t('EQUIPMENT_VIEWREQUEST');
  }

  if (tabData.some((item) => item.id === 'ManageEquipment')) {
    tabData.find((item) => item.id === 'ManageEquipment').component = (
      <ManageEquipmentTab refresh={refresh} setStopRefresh={setStopRefresh} />
    );
    tabData.find((item) => item.id === 'ManageEquipment').title = i18n.t('EQUIPMENT_MANAGE_EQUIPMENT');
  }

  // 刷新 list
  const refreshHandler = useCallback(() => {
    if (isSessionValid()) {
      setRefresh((preData) => !preData);
    }
  }, []);

  // 每分鐘刷新一次 list 的定時器
  useEffect(() => {
    if (!stopRefresh) {
      const timmer = setInterval(() => {
        refreshHandler();
      }, EQUIPMENT_INTERVAL);

      return () => {
        clearInterval(timmer);
      };
    }
  }, [refreshHandler, stopRefresh, tabData]);

  return (
    <div className={classes.root}>
      <TabBar
        data={loginInfo.flag ? tabData : []}
        setData={setTabData}
        width="14.875rem"
        NotificationBtn={
          <UpdateEquipmentStatus
            tabData={tabData}
            refresh={refresh}
            refreshHandler={refreshHandler}
            setStopRefresh={setStopRefresh}
            setBarcodeListener={setBarcodeListenerCtrl}
            displayTvDashboard={displayTvDashboard}
          />
        }
        id="update-equipment-status"
      />
      {!loginInfo.flag && <LoginPop />}
    </div>
  );
};

export default WardEquipment;
